module.exports = __webpack_public_path__ + "static/sandbox@3x-min-5f7f4e30659c4eb41d9e8a5f11bc00e4.png";